import request from "_private/utils/request";







//冷藏车温湿度动态明细监测点集合
export function FetchFindrefrigVelHumDetailByPage(data) {
    return request({
        url: "/report/VehicleHumitureDynamic/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

//车辆载重动态明细
export function FetchFreezerChartData(data) {
    return request({
        url: "/report/VehicleLoad/getDynamicByVehicle",
        method: "post",
        headers: {type: "json"},
        data
    });
}

// 监测点下拉树
export function FetchTreeNode(data) {
    return request({
        url: "/report/vehicle/alarmDetail/getTreeNodeData",
        method: "post",
        data
    });
}
